// /reports/telemetry flags a device id that is not registered instead of
// answering with an empty chart, so a typo can be told apart from "no data".
export const DEVICE_NOT_FOUND = 'device_not_found';

export const findUnregisteredDevices = (entries = []) =>
  entries
    .filter((entry) => entry?.error === DEVICE_NOT_FOUND)
    .map((entry) => entry.deviceId);
